export const actionTypePrefix = '@@CommentEditor';
export const reduxKey = '@@CommentEditor';
